import { createSelector, MemoizedSelector } from '@ngrx/store';
import { Order, StateUtils } from '@spartacus/core';
import { OrderState, StateWithOrder } from '../order-state';
import { getOrderState } from './feature.selector';

export const getOrderDetailsState: MemoizedSelector<StateWithOrder, StateUtils.LoaderState<Order>> = createSelector(
  getOrderState,
  (state: OrderState) => state.orderDetails,
);

export const getOrderDetails: MemoizedSelector<StateWithOrder, Order> = createSelector(
  getOrderDetailsState,
  (state: StateUtils.LoaderState<Order>) => StateUtils.loaderValueSelector(state),
);
